/* eslint-disable camelcase */
import { isTwin, reviewHasBadge, reviewHasColoredBadge } from "~/util/review";
import { IPoi } from "~/interfaces";
import { store } from "~/state/store";
import Scene from "~/scene";

export function getLoggerData(query: string, search: any, suggestData: any) {
	const loggerData: {
		q: string;
		index: number;
		status?: number;
		totalCount?: number;
		descStatus?: any;
		exact?: 0 | 1;
		text?: string;
		id?: string;
		source?: string;
		qtype?: number;
	} = {
		q: query.trim().toLowerCase(),
		index: -1,
	};

	if (search) {
		loggerData.status = search.resultStatus;

		if (search.resultStatus.toString().charAt(0) === "2") {
			loggerData.totalCount = search.getTotalCount();
			loggerData.descStatus = search.descriptionStatus;

			const data = search.getDetailData();

			if (data) {
				if (data.exact) {
					loggerData.exact = 1;
				}
				if (data.title) {
					loggerData.text = data.title;
				}
				if (data.source && data.id) {
					loggerData.id = data.id;
					loggerData.source = data.source;
				}
			}

			if (loggerData.index === -1) {
				const meta = search.getMeta();
				let qtype = 0;

				if (meta.hasGeo) {
					qtype = qtype | Mapy.Search.LOGGERCONST.HASGEO;
				}

				if (meta.hasService) {
					qtype = qtype | Mapy.Search.LOGGERCONST.HASSERVICE;
				}

				if (meta.deletedfromBack) {
					qtype = qtype | Mapy.Search.LOGGERCONST.DELETEDFROMBACK;
				}

				loggerData.qtype = qtype;
			}
		}
	} else if (suggestData) {
		const data = suggestData.data;
		const isCateogory = data.source === "poiC";

		loggerData.q = suggestData.prevPhrase.trim().toLowerCase().replace(/\//ug, "|");
		loggerData.text = query.trim();
		loggerData.index = data.iconType === "history" ? -3 : suggestData.position;
		loggerData.id = data.id;
		loggerData.source = data.source;

		if (isCateogory) {
			loggerData.index = -2;
		}
	}

	return loggerData;
}

export function logSearchSelection(query: string, search: any, loggerData: any, detailSearch: boolean) {
	const logObj: {
		index: number;
		query: string;
		name?: string;
		poi_title?: string;
		qaction?: string;
		result_type?: string;
		target?: string;
		search_purpose?: string;
		query_type?: string;
	} = {
		index: 1,
		query,
	};

	if (loggerData.text) {
		logObj.name = loggerData.text.trim();
		logObj.poi_title = loggerData.text.trim();
	}

	const action = search.getAction();

	if (action) {
		logObj.qaction = action.type;

		if (action.type === "route") {
			logObj.result_type = "route";
			logObj.target = "route";
		}
	}

	if (loggerData.target) {
		logObj.target = loggerData.target;
	}

	if (detailSearch) {
		logObj.search_purpose = "detail";
	}

	// analytika
	Mapy.Util.analyticsSearchSelection(logObj, loggerData, search.getDetailData());
}

type TSearchFilters = {[key: string]: { id: string; type: string; }};

// search results analytika
export function logSearchResult(query: string, source_input: string, search: any, searchFilters: TSearchFilters, searchOrigin: string) {
	const action = searchOrigin === "map_shift" ? null : search.getAction();
	const queryType = search.getQueryType();
	const corr = Mapy.getComponent("search").correction;
	const { longitude, latitude, zoom } = store.getState().map;
	const viewport = Scene.getViewport();
	const searchResult: {
		query: string;
		connectivity_source: string;
		search_center: string;
		total_count: number;
		qaction: string;
		correction: string;
		zoom: number;
		source_input: string;
		filter_id: string;
		filter_type: string;
		search_origin: string;
		query_type: string;
		page_no: number;
		search_top_left_corner: string;
		search_bottom_right_corner: string;
	} = {
		query,
		connectivity_source: "online",
		search_center: `${longitude},${latitude}`,
		total_count: search.getTotalCount(),
		qaction: action ? action.type : "",
		correction: "status" in corr && corr.status !== "nocorr" ? corr.status : "",
		zoom,
		source_input,
		filter_id: "",
		filter_type: "",
		search_origin: searchOrigin || "unknown",
		query_type: queryType,
		page_no: (search.getPage() || 0) + 1,
		search_top_left_corner: `${viewport.lbx}, ${viewport.rty}`,
		search_bottom_right_corner: `${viewport.rtx}, ${viewport.lby}`,
	};
	const filterIds = [];
	const filterTypes = [];

	Object.keys(searchFilters).forEach(key => {
		const item = searchFilters[key];

		filterIds.push(item.id);
		filterTypes.push(item.type);
	});

	searchResult.filter_id = filterIds.join(",");
	searchResult.filter_type = filterTypes.join(",");

	// odstranime prazdne veci
	Object.keys(searchResult).forEach(key => {
		const value = searchResult[key];

		// smazeme: prazdne stringy
		if (value === "") {
			delete searchResult[key];
		}
	});
	Mapy.getComponent("logger").log("search_result", searchResult);
}

export function logSearchResultList(search: any, searchFilters: TSearchFilters) {
	const allResults = search.getAllResults();
	const filterValues = Object.keys(searchFilters).filter(key => key !== "nyni-otevreno");
	const state = store.getState();
	const queryId = state.search.queryId || "";

	const searchResultList = {
		source: [],
		id: [],
		typeid: [],
		firmTwin: [],
		possibleRating: [],
		showRating: [],
		showReviews: [],
		reviewCountWeighted: [],
		reviewCount: [],
		filter: filterValues.length ? 1 : 0,
		showTextReviews: [],
		...queryId ? { query_id: queryId } : {},
	};

	allResults.filter(item => item.ready).slice(0, 10).forEach((item: IPoi) => {
		searchResultList.source.push(item.source);
		searchResultList.id.push(item.id);
		searchResultList.typeid.push(item.typeId || -1);
		searchResultList.firmTwin.push(isTwin(item) ? 1 : 0);
		searchResultList.possibleRating.push(item.review ? 1 : 0);
		searchResultList.showRating.push(item.review && reviewHasColoredBadge(item.review) ? 1 : 0);
		searchResultList.showReviews.push(item.review && reviewHasBadge(item.review) ? 1 : 0);
		searchResultList.reviewCountWeighted.push(item.review && item.review.review_weight ? parseFloat(item.review.review_weight.toFixed(3)) : 0);
		searchResultList.reviewCount.push(item.review ? item.review.total : 0);
		searchResultList.showTextReviews.push(item.review?.best_review ? 1 : 0);
	});

	// analytika
	Mapy.getComponent("logger").log("search_result_list", searchResultList);
}

export function logSuggestSearchSelection(suggestData: any, results: any, resultsType: any, purpose = "search") {
	const data = suggestData.data;
	const isCateogory = data.source === "poiC";
	const logObj: {
		query: string;
		search_type: string;
		index: number;
		results: any;
		results_type: any;
		name: string;
		target: string;
		search_purpose: string;
		result_type?: string;
	} = {
		query: suggestData.prevPhrase.trim().toLowerCase(),
		search_type: "suggestion",
		index: suggestData.position + 1,
		results,
		results_type: resultsType,
		name: isCateogory ? data.title.trim() : "",
		target: isCateogory ? "search" : "detail",
		search_purpose: purpose,
	};

	if (isCateogory) {
		logObj.result_type = "category";
	}

	// analytika - nove logovani sjednocene s appkou
	Mapy.Util.analyticsSearchSelection(logObj, isCateogory ? {} : data, data);
}


export function logClickArrowBack() {
	const state = store.getState();
	const queryId = state.search.queryId || "";

	Mapy.getComponent("logger").log("search_return_exact", {
		query: Mapy.getComponent("search").getQuery(),
		query_id: queryId || "",
		search_origin: "search",
	});
}
